import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63c112e2")

_pushScopeId("data-v-63c112e2")
const _hoisted_1 = {
  key: 0,
  class: "backspace"
}
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { class: "wrap" }
const _hoisted_5 = {
  key: 0,
  class: "title"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TabsGroup = _resolveComponent("TabsGroup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.drawerStore.opened)
      ? (_openBlock(), _createBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.isMobileScreen || _ctx.drawerStore.section === 'changeLayout')
      ? (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "drawer"
        }, {
          default: _withId(() => [
            (_ctx.drawerStore.opened)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "drawer",
                  ref: "PopUpRef",
                  style: { maxHeight: _ctx.maxHeight }
                }, [
                  _createVNode("div", _hoisted_2, [
                    (_ctx.title)
                      ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.title), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.isMobileScreen)
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: "close",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDrawer && _ctx.closeDrawer(...args)))
                        }))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ])
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }))
      : (_openBlock(), _createBlock(_Transition, {
          key: 2,
          name: "drawer"
        }, {
          default: _withId(() => [
            (_ctx.drawerStore.opened)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "drawer",
                  ref: "PopUpRef",
                  style: { maxHeight: _ctx.maxHeight }
                }, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode(_component_TabsGroup, {
                      class: "header",
                      activeTab: _ctx.activeTab,
                      "onUpdate:activeTab": [
                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = $event)),
                        _ctx.changeSection
                      ],
                      tabs: _ctx.tabs
                    }, null, 8, ["activeTab", "onUpdate:activeTab", "tabs"]),
                    (_ctx.title)
                      ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.title), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      class: "close",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDrawer && _ctx.closeDrawer(...args)))
                    }),
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ])
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }))
  ], 64))
})